/**
 * PostHog flag keys, deliberately alone in a module that imports nothing.
 *
 * Call sites read these at module scope — an offer definition naming the flag that gates it, for
 * instance. Keeping the enum importable without pulling in `posthog-js` or the tracking catalog
 * means such a read can never land on a half-initialised module: a spec that mocks
 * `usePostHog` with a factory keeps that factory running for the length of its `importOriginal`
 * subtree, and anything importing the enum from there mid-flight would see `undefined`.
 *
 * `usePostHog` re-exports this, so existing imports keep working either way.
 */
export enum PosthogFeatureFlags {
    UpsellContract = 'upsell-contract',
    UpsellHoldingStep = 'upsell-holding-step',
    UpsellBankingProvider = 'upsell-banking-provider',
    NewIncorporationFunnel = 'new-incorporation-funnel',
    FunnelAiSuggestions = 'funnel-ai-suggestions',
    NewProcessDetailsView = 'new-process-details-view',
    AirbillPromo = 'airbill-promo',
    UpsellMollie = 'upsell-mollie',
    /** A `conditional` **Sector** gets the 15-day **Extended processing time**. All-or-nothing, not a rollout. */
    ExtendedProcessingConditionalSector = 'extended-processing-conditional-sector',
    /** Kill switch: the share-transfer offers open the new funnel instead of the general workflow. Temporary. */
    ShareTransferFunnel = 'share-transfer-funnel',
}
